import React from 'react'
import { BottomBar, ContentContainer, PageContainer, WrapperProps } from '..'

export interface PageLayoutProps extends WrapperProps {
  showBottomBar?: boolean
}

export const PageLayout = ({
  showBottomBar = false,
  children
}: PageLayoutProps) => {
  return (
    <PageContainer>
      <ContentContainer>{children}</ContentContainer>
      {showBottomBar && <BottomBar showMobile />}
    </PageContainer>
  )
}
